import React from "react";
import { Link } from "gatsby";
import { motion } from "framer-motion";

import UTIcon from "./icons";
import { useAuthContext } from "../context/auth";
import { usePartnerContext } from "../context/partner";

const NAV_ITEMS = [
  {
    label: "Classroom",
    path: "/",
    icon: "classroom",
  },
  {
    label: "Messages",
    path: "/my-messages/",
    icon: "message",
  },
  {
    label: "Help",
    path: "/help/user-guide/",
    icon: "question",
  },
  {
    label: "Account",
    path: "/my-account/",
    icon: "user",
  },
];

export default function MobileBottomNav() {
  const { colors } = usePartnerContext();
  const { conversations } = useAuthContext();

  const path = typeof window !== "undefined" ? window.location.pathname : "";

  const unreadConversations =
    conversations?.filter((convo) => convo.fromUnread === true) || [];

  return (
    <motion.nav
      className="fixed bottom-0 left-0 right-0 z-40 lg:hidden border-t shadow-[0_-2px_10px_rgba(0,0,0,0.1)]"
      style={{
        backgroundColor: colors.white,
        borderColor: colors.border || colors.gray200,
      }}
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ type: "spring", damping: 25, stiffness: 300 }}
    >
      <div className="flex items-center justify-around h-16 px-2">
        {NAV_ITEMS.map((item) => {
          const isActive = path === item.path;
          const hasNotification =
            item.path === "/my-messages/" && unreadConversations.length > 0;

          return (
            <Link
              key={item.path}
              to={item.path}
              className="flex flex-col items-center justify-center flex-1 h-full relative"
            >
              {/* Active indicator */}
              {isActive && (
                <motion.div
                  className="absolute top-0 left-0 right-0 flex justify-center"
                  layoutId="activeTab"
                  transition={{ type: "spring", damping: 25, stiffness: 300 }}
                >
                  <div
                    className="h-0.5 w-12 rounded-full"
                    style={{
                      backgroundColor: colors.primary,
                    }}
                  />
                </motion.div>
              )}

              <motion.div
                className="flex flex-col items-center justify-center"
                whileTap={{ scale: 0.9 }}
                transition={{ duration: 0.1 }}
              >

                {/* Icon with notification badge */}
                <div className="relative">
                  <UTIcon
                    type={item.icon as any}
                    size={24}
                    color={
                      isActive
                        ? colors.primary
                        : colors.gray8 || colors.textColor
                    }
                  />
                  {hasNotification && (
                    <motion.div
                      className="absolute -top-1 -right-1 flex items-center justify-center font-bold text-[10px] rounded-full min-w-[16px] h-[16px] px-1"
                      style={{
                        backgroundColor: colors.primary,
                        color: colors.primaryText,
                      }}
                      initial={{ scale: 0 }}
                      animate={{ scale: 1 }}
                      transition={{ type: "spring", damping: 15, stiffness: 400 }}
                    >
                      {unreadConversations.length}
                    </motion.div>
                  )}
                </div>

                {/* Label */}
                <span
                  className={`text-xs mt-1 ${
                    isActive ? "font-semibold" : "font-medium"
                  }`}
                  style={{
                    color: isActive
                      ? colors.primary
                      : colors.gray8 || colors.textColor,
                  }}
                >
                  {item.label}
                </span>
              </motion.div>
            </Link>
          );
        })}
      </div>
    </motion.nav>
  );
}
